/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const PhysicalActivityIcon = props => {
	const { color = '' } = props
	return (
		<svg
			id='Layer_1'
			xmlns='http://www.w3.org/2000/svg'
			x={0}
			y={0}
			viewBox='0 0 24 24'
			style={{
				enableBackground: 'new 0 0 24 24'
			}}
			xmlSpace='preserve'
			width='1em'
			height='1em'
			{...props}
		>
			<style>{`.st0{fill: ${color}}`}</style>
			<g id='_25_icono_cuerpo_arte' transform='translate(-19.9 464.951)'>
				<g id='Group_7525' transform='translate(53.9 -34.1)'>
					<g id='XMLID_123_' transform='translate(5.69 2.766)'>
						<g id='XMLID_125_' transform='translate(4.688)'>
							<path
								id='Path_13022'
								className='st0'
								d='M-32.4-427.6c-.9 0-1.6-.7-1.6-1.6 0-.9.7-1.6 1.6-1.7.9 0 1.6.7 1.7 1.6v.1c0 .9-.8 1.6-1.7 1.6zm0-2.5c-.5 0-.9.4-.9.9s.4.9.9.9.9-.4.9-.9-.4-.9-.9-.9z'
							/>
						</g>
						<g id='XMLID_124_' transform='translate(0 .176)'>
							<path
								id='Path_13023'
								className='st0'
								d='M-29.7-412.6h-.1c-.6-.1-1.1-.6-1-1.3l.7-7.5v-3.8l-3.7-3.8c-.4-.4-.4-1.1 0-1.5.2-.2.4-.3.7-.3.3 0 .5.1.7.3l3.3 3.5c.8-.5 1.8-.5 2.6 0l3.3-3.5c.4-.4 1-.4 1.4 0 .4.4.4 1.1 0 1.5l-3.7 3.8v3.9l.7 7.5c.1.6-.4 1.2-1 1.3-.6.1-1.2-.4-1.3-1.1l-.7-7.2h-.3l-.7 7.2c0 .3-.2.6-.4.8.1.1-.2.2-.5.2zm1.6-8.9h.9c.2 0 .3.1.4.3l.7 7.5c0 .1.1.2.2.3.1.1.2.1.3.1.1 0 .2-.1.3-.2.1-.1.1-.2.1-.3l-.7-7.5v-4c0-.1 0-.2.1-.3l3.8-3.9c.1-.1.1-.3 0-.4-.1-.1-.3-.1-.4 0l-3.6 3.7c-.1.1-.3.1-.5 0-.6-.6-1.6-.6-2.2 0-.1.1-.3.1-.5 0l-3.6-3.7c-.1-.1-.1-.1-.2-.1s-.1 0-.2.1-.1.3 0 .4l3.8 3.9c.1.1.1.2.1.3v4l-.7 7.5c0 .1 0 .2.1.3.1.1.2.1.3.2.1 0 .2 0 .3-.1.1-.1.1-.2.2-.3l.7-7.5c-.1-.2.1-.3.3-.3z'
							/>
						</g>
					</g>
					<g id='Group_6964'>
						<path
							id='Path_13024'
							className='st0'
							d='M-22-406.9c-6.6 0-12-5.4-12-12s5.4-12 12-12 12 5.4 12 12c0 6.7-5.4 12-12 12zm0-23.2c-6.2 0-11.3 5-11.3 11.3 0 6.2 5 11.3 11.3 11.3s11.3-5 11.3-11.3c0-6.3-5.1-11.3-11.3-11.3z'
						/>
					</g>
				</g>
			</g>
		</svg>
	)
}

export default PhysicalActivityIcon
